// Home is the workspace launcher (pages/home/HomePage.jsx).
export const HOME_ROUTE = '/home';

/**
 * Where to land after a successful sign-in.
 *
 * ProtectedRoute hands SignIn the path the visitor originally asked for. It
 * travels in router state rather than the URL, but it is still treated as
 * untrusted input: only a single-slash relative path is accepted, so
 * "//evil.example.com" and "https://…" — both of which navigate() would happily
 * follow off-site — cannot turn the login form into an open redirect.
 *
 * Lives in its own module so it can be tested directly and so the rule has one
 * definition rather than one per caller.
 */
export const getSafeRedirect = (requestedPath) => {
  if (typeof requestedPath !== 'string') return HOME_ROUTE;
  if (!requestedPath.startsWith('/') || requestedPath.startsWith('//')) return HOME_ROUTE;
  // Bouncing back to /login would loop straight into the redirect-if-signed-in
  // guard in App.
  if (requestedPath === '/login') return HOME_ROUTE;
  return requestedPath;
};
